export enum MessageAnnouncementChannelType {
  Polite = 'polite',
  Assertive = 'assertive',
}
